var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotification = function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.5 18.788v-1.5h1.808V9.828q0-2.017 1.245-3.567a5.52 5.52 0 0 1 3.197-1.983v-.623q0-.52.364-.886.365-.364.885-.364t.885.364.366.886v.623a5.52 5.52 0 0 1 3.197 1.983q1.245 1.55 1.245 3.567v7.462H19.5v1.5zm7.498 2.808q-.746 0-1.276-.53a1.74 1.74 0 0 1-.53-1.278h3.616q0 .75-.532 1.278-.531.53-1.278.53m-4.19-4.307h8.384V9.827q0-1.737-1.228-2.964Q13.737 5.635 12 5.635T9.036 6.863Q7.808 8.09 7.808 9.827z"
  })));
};
export default SvgNotification;